import { render, staticRenderFns } from "./ChartPie.vue?vue&type=template&id=51d23027&"
import script from "./ChartPie.ts?vue&type=script&lang=ts&"
export * from "./ChartPie.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports